import { FieldValues, Path } from "react-hook-form";

import { FormMoneyInput } from "../../../components/Input";
import { CardLabel, HelperText } from "../../../components/MobileForm/styles";
import { CHARGE_FIELD_NAMES, CHARGE_LABELS } from "./constants";
import { chargeRule } from "./tradeValidation";
import { ChargeFieldProps } from "./types";

/**
 * The compact twin of `ChargeField`. A fragment, not a card: every compact form
 * places the charge inside the amount's card, so the two figures stay together
 * on one screen. Label and rule come from the same two modules its desktop
 * sibling reads, which is what stops the surfaces naming or gating one field
 * differently.
 */
export const MobileChargeField = <T extends FieldValues>({
  id,
  control,
  charge,
  helper,
  isSubmitting,
  taxedIncome,
}: ChargeFieldProps<T>) => (
  <>
    <CardLabel htmlFor={id}>{CHARGE_LABELS[charge]}</CardLabel>
    <FormMoneyInput
      id={id}
      name={CHARGE_FIELD_NAMES[charge] as Path<T>}
      control={control}
      rules={{ validate: chargeRule(charge, taxedIncome) }}
      disabled={isSubmitting}
      placeholder="0.00"
    />
    <HelperText>{helper}</HelperText>
  </>
);
